/**
 * Gallery + Text layout (bskr/layout-gallery-text) — assets reveal as they
 * enter the viewport: opacity 0→1 with a subtle scale from the asset's centre.
 *
 * Loaded globally (layouts can't ship reliable per-block scripts). Each asset
 * animates on its own ScrollTrigger so they appear as you scroll past them.
 * Skips the editor and respects prefers-reduced-motion (assets stay visible).
 */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initBlock(root) {
  if (root.dataset.galleryRevealInited === "1") return;

  const cards = root.querySelectorAll(".bskr-responsive-asset");
  if (!cards.length) return;

  // Inside a Content Slider slide the vertical scroll trigger can't fire (the
  // slide is translated horizontally); skip the reveal so the assets keep their
  // default visible state (see content-slider.js / content-slide markup).
  if (root.closest("[data-no-scroll-reveal]")) return;

  root.dataset.galleryRevealInited = "1";
  // Flag the section so the CSS hides the assets before GSAP takes over
  // (no flash); only added here, so no-JS users keep them visible.
  root.classList.add("is-anim-ready");

  cards.forEach((card) => {
    gsap.set(card, { opacity: 0, scale: 0.92 }); // scale origin defaults to centre
    gsap.to(card, {
      opacity: 1,
      scale: 1,
      duration: 0.7,
      ease: "power2.out",
      scrollTrigger: {
        trigger: card,
        start: "top 90%",
        once: true,
      },
    });
  });
}

function init() {
  // Skip in the editor; leave reduced-motion users with static, visible assets.
  if (typeof window !== "undefined" && window.wp && window.wp.data) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  document
    .querySelectorAll(".wp-block-bskr-layout-gallery-text")
    .forEach(initBlock);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
